import script from "./MenuContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuContent.vue?vue&type=script&lang=ts&setup=true"

import "./MenuContent.vue?vue&type=style&index=0&id=77e74b43&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77e74b43"]])

export default __exports__